<ion-toolbar style="padding:0px 15px;" color="warning" *ngIf="isUpdateVersion && !isMobilePlatform">
  <div class="updated-toolbar-container">
    <p style="margin-right: 6px;">{{messageBanner}}</p>
    <ion-button *ngIf="isUpdatedFinish" size="small" (click)="reloadPage()">reload</ion-button>
  </div>
</ion-toolbar>
